import { createFileRoute } from "@tanstack/react-router"
import LtiDeepLinkPage from "@/routes/-pages/LtiDeepLink"
import type { LtiDeepLinkSearchParams } from "@/utils/ltiDeepLink"

export const Route = createFileRoute("/lti/deep-link")({
  validateSearch: (search: Record<string, unknown>): LtiDeepLinkSearchParams => ({
    resource_title: typeof search.resource_title === "string" ? search.resource_title : undefined,
    course_id: typeof search.course_id === "string" ? search.course_id : undefined,
    accept_types: typeof search.accept_types === "string" ? search.accept_types : undefined,
    accept_presentation_document_targets:
      typeof search.accept_presentation_document_targets === "string"
        ? search.accept_presentation_document_targets
        : undefined,
    accept_media_types: typeof search.accept_media_types === "string" ? search.accept_media_types : undefined,
    accept_multiple: typeof search.accept_multiple === "string" ? search.accept_multiple : undefined,
    accept_lineitem: typeof search.accept_lineitem === "string" ? search.accept_lineitem : undefined,
    auto_create: typeof search.auto_create === "string" ? search.auto_create : undefined,
  }),
  component: LtiDeepLinkRoute,
})

function LtiDeepLinkRoute() {
  const search = Route.useSearch()
  return <LtiDeepLinkPage search={search} />
}
